import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PhoneBar, FloatingCallButton } from "@/components/PhoneCTA";
import CookieConsent from "@/components/CookieConsent";
import Landing from "@/pages/Landing";
import SearchResults from "@/pages/SearchResults";
import BookingFlow from "@/pages/BookingFlow";
import BookingSuccess from "@/pages/BookingSuccess";
import PaymentReturn from "@/pages/PaymentReturn";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import BlogPost from "@/pages/BlogPost";
import Journal from "@/pages/Journal";
import RoutePage from "@/pages/RoutePage";
import DestinationPage from "@/pages/DestinationPage";
import DestinationsIndex from "@/pages/DestinationsIndex";
import { Privacy, Terms, Cookies, DataProtection } from "@/pages/Legal";
import "@/App.css";

function SiteShell({ children }) {
  return (
    <>
      <PhoneBar />
      {children}
      <FloatingCallButton />
      <CookieConsent />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<SiteShell><Landing /></SiteShell>} />
          <Route path="/search" element={<SiteShell><SearchResults /></SiteShell>} />
          <Route path="/booking" element={<SiteShell><BookingFlow /></SiteShell>} />
          <Route path="/booking-success/:reference" element={<SiteShell><BookingSuccess /></SiteShell>} />
          <Route path="/booking/success" element={<SiteShell><PaymentReturn /></SiteShell>} />
          <Route path="/contact" element={<SiteShell><Contact /></SiteShell>} />
          <Route path="/blog/:slug" element={<SiteShell><BlogPost /></SiteShell>} />
          <Route path="/journal" element={<SiteShell><Journal /></SiteShell>} />
          <Route path="/flights/:slug" element={<SiteShell><RoutePage /></SiteShell>} />
          <Route path="/destinations" element={<SiteShell><DestinationsIndex /></SiteShell>} />
          <Route path="/destinations/:code" element={<SiteShell><DestinationPage /></SiteShell>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/privacy" element={<SiteShell><Privacy /></SiteShell>} />
          <Route path="/terms" element={<SiteShell><Terms /></SiteShell>} />
          <Route path="/cookies" element={<SiteShell><Cookies /></SiteShell>} />
          <Route path="/data-protection" element={<SiteShell><DataProtection /></SiteShell>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}
